














































































































































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from '~/utils/constants/product';
import accessibility from '~/utils/solepro/accessibility';
import { ProductForProductPageType } from '~/utils/types/solepro/Product';
import AddToCart from '~/components/solepro/AddToCart.vue';
import { getSecondPriceLabel } from '~/utils/helpers/product';
import { productConfigureTrack, productUpgradeTrack } from '~/helpers/trackings/24orepro/products';

export default defineComponent({
    components: {
        AddToCart,
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        betterOffer: {
            type: Object as PropType<ProductForProductPageType>,
            required: false
        },
        priceLabels: {
            required: true,
            type: Array as PropType<string[]>
        },
        frequency: {
            type: String
        },
        inCarousel: {
            default: false
        },
        showButton: {
            default: true
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup(props) {
        const choosenModules = ref<String[]>([])
        const choosenModulesData = ref<{ [key: string]: { sku: string, name: string, box_description: string } }>({})
        const configureButton = ref();
        const configureModal = ref();
        const stepNumber = ref(1);
        const productConfiguration = ref(null);/**@TODO? */
        const tipoConsegna = ref(); /**@TODO */
        const sanitizedSku = props.product.sku.replace(/\./g, '');
        const modalId = 'purchase-modal-' + sanitizedSku;
        const usedModalId = ref(modalId);
        const { app: { i18n }, $fc } = useContext()
        let betterOfferPrice;
        let betterOfferMoreProducts;
        let betterOfferSanitizedSku;
        if (props.betterOffer) {
            const regex = /[0-9]+[.,][0-9+]/g;
            const productPriceMatch = props.priceLabels[1].match(regex);
            const productPrice = productPriceMatch[1] || productPriceMatch[0]
            const secondLine = getSecondPriceLabel(props.betterOffer, props.frequency, i18n, $fc) as string
            const nextPrice = regex.exec(secondLine)[0]
            betterOfferPrice = parseInt(nextPrice) - parseInt(productPrice)
            betterOfferMoreProducts = props.betterOffer.modulesInCartQty.min - props.product.modulesInCartQty.min;
            betterOfferSanitizedSku = props.betterOffer.sku.replace(/\./g, '');

        }

        const toggleModule = (moduleSku) => {
            if (choosenModules.value.includes(moduleSku)) {
                const index = choosenModules.value.indexOf(moduleSku);
                choosenModules.value.splice(index, 1);
                delete choosenModulesData.value[moduleSku]
            } else if (choosenModules.value.length < props.product.modulesInCartQty.min) {
                choosenModules.value.push(moduleSku)
                const mod = props.product.modules.find(el => el.product.sku == moduleSku)
                choosenModulesData.value[moduleSku] = {
                    sku: moduleSku,
                    name: mod.product.name,
                    box_description: mod.product.box_description ? mod.product.box_description : (mod.product.short_description ? mod.product.short_description.html : '')
                }
            }
        }
        
        const isEmptySubtitle = (modalSubtitle)=>{
            return !modalSubtitle || modalSubtitle==''
        }
        const getModalSubtitle = item=>{
            item = item.product ?? item;
            let modalSubtitle = item?.box_description;
            if(isEmptySubtitle(modalSubtitle)){
                const shortDescription = !!item.shortDescription ? item.shortDescription?.html : item.short_description?.html;
                modalSubtitle = shortDescription
                if(shortDescription && !shortDescription.hasOwnProperty('html')){
                    modalSubtitle = shortDescription;
                }
            }
            return modalSubtitle

        }


        return {
            getModalSubtitle,
            sanitizedSku,
            choosenModules,
            configureButton,
            configureModal,
            toggleModule,
            stepNumber,
            choosenModulesData,
            productConfiguration,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            tipoConsegna,
            modalId,
            betterOfferPrice,
            betterOfferMoreProducts,
            betterOfferSanitizedSku,
            usedModalId,
            scalapaySelector: '["#campaign-price-container-secondary-'+sanitizedSku+'","#campaign-price-container-'+sanitizedSku+'"]'
        }
    },
    mounted() {
        if (this.showButton) accessibility.accessibleModal(this.$refs.configureButton as HTMLButtonElement)
        const modal = this.inCarousel ? document.getElementById(this.modalId) : this.$refs.configureModal as HTMLElement;
        const closeBtns = modal.querySelectorAll('.js-close-accessible-dialog');
        const overlay = document.getElementById('modal-backdrop');

        const closeModal = this.closeModal;
        overlay.addEventListener("click", (e) => {
            // @ts-ignore
            closeModal(false)
        })

        modal.addEventListener("keydown", (evt) => {
            if (evt.key === "Escape") {
                // @ts-ignore
                closeModal(false);
            }
        });
    },
    methods: {
        handleKeydown(e) {
            const modal = this.inCarousel ? document.getElementById(this.modalId) : this.$refs.configureModal as HTMLElement;
            const closeBtns = modal.querySelectorAll('.js-close-accessible-dialog') as NodeListOf<HTMLElement>
            if (e.key === "Tab" && !e.shiftKey) {
                closeBtns[0].focus();
            } else if(e.key=='Enter' || e.key==' ' || e.code=='Space'){
                e.target.click()
            }
        },
        openModal(evt, modalId?: string) {
            this.usedModalId = modalId || this.modalId;
            const modal = document.getElementById(this.usedModalId)
            const overlay = document.getElementById('modal-backdrop');
            // Add overlay before modal
            overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');

            // Show modal
            modal.classList.add('show');

            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        },
        closeModal(keepOverlay: Boolean) {
            const modal = document.getElementById(this.usedModalId);
            const overlay = document.getElementById('modal-backdrop');
            if(!modal) return;
            modal.classList.remove('show');

            if (!keepOverlay) overlay.classList.add('hidden');
            document.body.classList.remove('modal-open');
            this.choosenModules = [];
            this.choosenModulesData = {};
            this.stepNumber = 1;
        },
        changeModal(modalId) {
            productUpgradeTrack(this.product)
            this.closeModal(false);
            this.openModal(null, modalId);
        },
        changeStep(stepNumber) {
            this.stepNumber = stepNumber;
            const modal = this.inCarousel ? document.getElementById(this.modalId) : this.$refs.configureModal as HTMLElement;
            if(stepNumber==1){
                setTimeout(()=>{
                    const checkboxes = Array.from(this.$el.querySelectorAll('input[type="checkbox"]')) as HTMLElement[];
                    checkboxes[0].focus();
                },0)
            }else{
                (this.$el.querySelector(".advance-button") as HTMLElement).focus();
                productConfigureTrack(this.choosenModules)
            }
            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        }
    }
})
